<template>
  <div class="container-fluid">
    <loading :active.sync="isLoading" :enforce-focus="false" loader="dots" />

    <div class="card search-card">
      <div class="card-body">
        <div class="form-row">
          <div class="col-sm-3 col-md">
            <div class="form-group">
              <label for="searchKeyword">
                {{ i18n("ORGANIZATION.EMPLOYEE_SEARCH") }}
              </label>
              <el-input
                id="searchKeyword"
                clearable
                placeholder="請輸入帳號或姓名或Email或工號"
                @keydown.stop.prevent.enter="
                  searchPerson({
                    page: 1,
                    per_page: 10,
                  })
                "
                v-model.trim="searchKeyword"
              />
            </div>
          </div>

          <div class="col-sm-3 col-md-4">
            <button
              type="button"
              class="btn btn-primary"
              style="margin-top: 30px; margin-right: 5px"
              @click="
                searchPerson({
                  page: 1,
                  per_page: 10,
                })
              "
            >
              {{ i18n("BUTTON.SEARCH") }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              style="margin-top: 30px; margin-right: 5px"
              data-toggle="modal"
              data-target="#personModal"
              @click="personModal(true)"
            >
              {{ i18n("BUTTON.ADD_EMPLOYEE") }}
            </button>
            <button
              type="button"
              class="btn btn-info"
              style="margin-top: 30px"
              data-toggle="modal"
              data-target="#uploadModal"
            >
              {{ i18n("BUTTON.IMPORT_DATA") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="content-wrap">
      <div class="tree-wrap" style="cursor: default">
        <VueTreeList
          @click="onClick"
          @drop="drop"
          :model="tree"
          v-bind:default-expanded="true"
        >
          <template v-slot:leafNameDisplay="slotProps">
            <div
              class="node"
              :class="{ 'active-node': slotProps.model.id === selectedNode }"
            >
              <div class="node-content">
                <div style="display: inline-block; vertical-align: top">
                  <div class="department-name">
                    {{ slotProps.model.DepartmentName }}
                  </div>
                  <span class="department-code">
                    {{ slotProps.model.DepartmentCode }}
                  </span>
                </div>

                <span
                  class="add-folder"
                  style="margin-left: 5px"
                  @click="addDepartment(slotProps.model)"
                >
                  <eva-icon width="16" height="16" name="plus-outline" />
                </span>

                <span
                  v-if="slotProps.model.pid !== 0"
                  class="edit-folder"
                  style="margin-left: 5px"
                  @click="editDepartment(slotProps.model)"
                >
                  <eva-icon width="16" height="16" name="edit-outline" />
                </span>

                <span
                  v-if="
                    slotProps.model.pid !== 0 &&
                    slotProps.model.id === selectedNode
                  "
                  class="delete-folder"
                  style="margin-left: 5px"
                  @click="onDel(slotProps.model)"
                >
                  <eva-icon width="16" height="16" name="trash-2-outline" />
                </span>
              </div>
            </div>
          </template>

          <span style="display: none" class="icon" slot="treeNodeIcon">🌲</span>
          <span style="display: none" class="icon" slot="addTreeNodeIcon">
            📂
          </span>
          <span style="display: none" class="icon" slot="addLeafNodeIcon">
            ＋
          </span>
          <span style="display: none" class="icon" slot="editNodeIcon">📃</span>
          <span style="display: none" class="icon" slot="delNodeIcon">✂️</span>
        </VueTreeList>
      </div>

      <div class="department-wrap">
        <div class="yahome-table-wrap">
          <div style="text-align: right; margin-bottom: 10px"></div>

          <VueBootstrap4Table
            :rows="rows"
            :columns="columns"
            :config="config"
            :total-rows="totalData"
            @on-change-query="onChangeQuery"
          >
            <!-- 帳號 -->
            <template slot="account" slot-scope="props">
              <button
                class="btn btn-primary"
                type="button"
                data-toggle="modal"
                data-target="#personModal"
                @click="personModal(false, props.row)"
              >
                {{ props.row.Account }}
              </button>
            </template>

            <!-- 部門主管 -->
            <template slot="slot_supervisor" slot-scope="props">
              <el-switch
                v-model="props.row.IsSupervisor"
                active-color="#13ce66"
                inactive-color="#808080"
                @change="setSupervisor(props.row)"
              />
            </template>

            <!-- 啟用 -->
            <template slot="slot_IsEnabled" slot-scope="props">
              <el-switch
                v-model="props.row.IsEnabled"
                active-color="#13ce66"
                inactive-color="#808080"
                @change="setIsEnabled(props.row)"
              />
            </template>

            <!-- 刪除 -->
            <template slot="delete" slot-scope="props">
              <button
                type="button"
                class="btn btn-danger btn-delete btn-sm"
                data-toggle="modal"
                data-target="#delPersonModal"
                @click.capture="delModal(props.row)"
              >
                {{ i18n("BUTTON.DELETE") }}
              </button>
            </template>
            <template slot="empty-results">{{
              i18n("PUBLIC.NO_RESULT")
            }}</template>
          </VueBootstrap4Table>
        </div>
      </div>
    </div>

    <!-- 新增 & 編輯部門 Modal -->
    <div
      id="departmentModal"
      class="modal fade"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <ValidationObserver
            ref="department"
            class="modal-content"
            v-slot="{ handleSubmit, reset }"
          >
            <form
              @submit.prevent="handleSubmit(saveDepartment)"
              @reset.prevent="reset"
            >
              <div class="modal-header">
                <span v-if="isAddDepartment">
                  <span class="badge badge-primary" style="font-size: 15px">
                    {{ ParentDepartmentName }}
                  </span>
                  {{ i18n("ORGANIZATION.ADD_DEPARTMENT") }}
                </span>
                <span v-else>{{ i18n("ORGANIZATION.EDIT_DEPARTMENT") }}</span>
              </div>
              <div class="modal-body">
                <!-- 部門名稱 -->
                <div class="form-group">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <label for="DepartmentName">
                      <span class="mark">*</span>
                      {{ i18n("ORGANIZATION.DEPARTMENT_NAME") }}
                    </label>
                    <input
                      type="text"
                      id="DepartmentName"
                      class="form-control"
                      v-model.trim="department.DepartmentName"
                    />
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>
                <!-- 部門代碼 -->
                <div class="form-group">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <label for="DepartmentCode">
                      <span class="mark">*</span>
                      {{ i18n("ORGANIZATION.DEPARTMENT_CODE") }}
                      <span class="mark">(不可重複)</span>
                    </label>
                    <input
                      type="text"
                      id="DepartmentCode"
                      class="form-control"
                      v-model.trim="department.DepartmentCode"
                    />
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="reset"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                >
                  {{ i18n("BUTTON.CANCEL") }}
                </button>
                <button type="submit" class="btn btn-success">
                  {{ i18n("BUTTON.SAVE") }}
                </button>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
    </div>

    <!-- 刪除部門 Modal -->
    <div
      id="delDepartmentModal"
      class="modal fade"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <span>{{ i18n("ORGANIZATION.DELETE_DEPARTMENT") }}</span>
          </div>
          <div v-if="canDelete" class="modal-body">
            確認刪除<span style="font-weight: bolder; color: red">
              {{ department.DepartmentName }}
            </span>
            ?
          </div>
          <div v-else class="modal-body">
            若欲刪除
            <span style="font-weight: bolder; color: red">
              {{ department.DepartmentName }} </span
            >，需先刪除底下的
            <span style="font-weight: bolder; color: red">部門及人員</span>。
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              @click="canDelete = false"
            >
              {{ i18n("BUTTON.CANCEL") }}
            </button>
            <button
              v-if="canDelete"
              type="button"
              class="btn btn-danger"
              @click="delDepartment"
            >
              {{ i18n("BUTTON.DELETE") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 新增 & 編輯人員 Modal -->
    <div
      class="modal fade"
      id="personModal"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <ValidationObserver
          ref="person"
          class="modal-content"
          v-slot="{ handleSubmit, reset }"
        >
          <form
            @submit.prevent="handleSubmit(savePerson)"
            @reset.prevent="reset"
          >
            <div class="modal-header">
              <span v-if="isPersonAdd">
                {{ i18n("ORGANIZATION.ADD_EMPLOYEE") }}
              </span>
              <span v-else>{{ i18n("ORGANIZATION.EDIT_EMPLOYEE") }}</span>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <label for="Account">
                    <span class="mark">*</span>
                    {{ i18n("ORGANIZATION.ACCOUNT") }}
                  </label>
                  <el-input
                    id="Account"
                    clearable
                    maxlength="50"
                    :disabled="!isPersonAdd"
                    v-model.trim="person.Account"
                  />
                  <span class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>

              <div class="form-group">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <label for="UserName">
                    <span class="mark">*</span>
                    {{ i18n("ORGANIZATION.USERNAME") }}
                  </label>
                  <el-input
                    id="UserName"
                    clearable
                    maxlength="50"
                    v-model.trim="person.UserName"
                  />
                  <span v-if="errors[0]" class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>

              <div class="form-group">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <label for="EmployeeNo">
                    <span class="mark">*</span>
                    工號
                  </label>
                  <el-input
                    id="EmployeeNo"
                    clearable
                    maxlength="20"
                    v-model.trim="person.EmployeeNo"
                  />
                  <span v-if="errors[0]" class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>

              <div class="form-group">
                <ValidationProvider
                  :name="i18n('ORGANIZATION.EMAIL')"
                  rules="required|email"
                  v-slot="{ errors }"
                >
                  <label for="Email">
                    <span class="mark">*</span>
                    {{ i18n("ORGANIZATION.EMAIL") }}
                  </label>
                  <el-input
                    id="Email"
                    clearable
                    maxlength="50"
                    v-model.trim="person.Email"
                  />
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <div class="form-group">
                <ValidationProvider
                  :name="i18n('ORGANIZATION.PHONE')"
                  rules="required|numeric"
                  v-slot="{ errors }"
                >
                  <label for="PhoneNumber">
                    <span class="mark">*</span>
                    {{ i18n("ORGANIZATION.PHONE") }}
                  </label>
                  <el-input
                    id="PhoneNumber"
                    clearable
                    maxlength="20"
                    v-model.trim="person.PhoneNumber"
                  />
                  <span class="text-danger">{{ errors[0] }} </span>
                </ValidationProvider>
              </div>

              <div class="form-group">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <label for="">
                    <span class="mark">*</span>
                    {{ i18n("ORGANIZATION.PRIMARY_DEPARTMENT") }}
                  </label>
                  <treeselect
                    :options="departmentList"
                    :searchable="true"
                    :show-count="true"
                    :default-expand-level="1"
                    placeholder="請選擇"
                    v-model="mainDepartment.DepartmentGuid"
                  />
                  <span v-if="errors[0]" class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>

              <div class="form-group">
                <label for="">
                  <span class="mark">*</span>
                  {{ i18n("ORGANIZATION.IS_SUPERVISOR") }}
                </label>
                <el-select
                  class="w-100"
                  v-model="mainDepartment.IsSupervisor"
                >
                  <el-option label="是" :value="true" />
                  <el-option label="否" :value="false" />
                </el-select>
              </div>

              <div class="form-group">
                <hr />
                <div
                  v-for="(item, index) in othersDepartment"
                  :key="index"
                  style="
                    margin-bottom: 20px;
                    display: flex;
                    justify-content: space-between;
                    font-size: 0.9em;
                  "
                >
                  <div style="flex: 1">
                    {{ i18n("ORGANIZATION.ADJUNCT_DEPARTMENT") }}
                    <span
                      style="
                        background-color: rgb(236 241 255);
                        border-radius: 5px;
                        padding: 5px 10px;
                      "
                    >
                      {{ item.DepartmentName }}
                    </span>
                  </div>
                  <div style="margin-right: 10px">
                    {{ i18n("Basic.Supervisor") }}
                    <span
                      style="
                        background-color: rgb(236 241 255);
                        border-radius: 5px;
                        padding: 5px 10px;
                      "
                    >
                      {{ item.IsSupervisor ? "是" : "否" }}
                    </span>
                  </div>

                  <button
                    type="button"
                    class="btn btn-danger btn-sm"
                    @click="delItem(index)"
                  >
                    <eva-icon fill="#FFF" name="trash-2-outline"></eva-icon>
                  </button>
                </div>
                <div>
                  <AddDepartment
                    v-if="addOthersDepartment"
                    @addDoubleAs="saveData"
                    @addCancel="addOthersDepartment = false"
                  />
                  <button
                    v-if="!addOthersDepartment"
                    type="button"
                    class="btn btn-primary btn-sm"
                    @click="addOthersDepartment = true"
                  >
                    <i class="fas fa-plus"></i>
                    {{ i18n("ORGANIZATION.ADJUNCT_DEPARTMENT") }}
                  </button>
                </div>
              </div>

              <div class="form-group">
                <label for="">{{ i18n("ORGANIZATION.ROLE") }}</label>
                <treeselect
                  :multiple="true"
                  :options="roleOptions"
                  placeholder="請選擇"
                  valueFormat="object"
                  v-model="personRoles"
                />
              </div>
            </div>
            <div class="modal-footer">
              <button
                v-if="!isPersonAdd"
                type="button"
                class="btn btn-warning"
                @click="changePassword"
              >
                {{ i18n("ORGANIZATION.CHANGE_PASSWORD") }}
              </button>
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                {{ i18n("BUTTON.CANCEL") }}
              </button>
              <button type="submit" class="btn btn-success">
                {{ i18n("BUTTON.SAVE") }}
              </button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <!-- 刪除人員 Modal -->
    <div
      class="modal fade"
      id="delPersonModal"
      tabindex="-1"
      aria-labelledby="delPersonModal"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <span>{{ i18n("ORGANIZATION.DELETE_EMPLOYEE") }}</span>
          </div>
          <div class="modal-body">
            確認刪除
            <span style="font-weight: bolder; color: red">
              {{ person.Name }}
            </span>
            ?
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              {{ i18n("BUTTON.CANCEL") }}
            </button>
            <button
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
              @click="delPerson"
            >
              {{ i18n("BUTTON.DELETE") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 匯入資料 Modal -->
    <div class="modal fade" id="uploadModal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <span>{{ i18n("BUTTON.IMPORT_DATA") }}</span>
          </div>
          <div class="modal-body" style="margin-bottom: 20px">
            <p class="form-group">
              <u
                style="color: midnightblue; cursor: pointer"
                @click.prevent="downloadTemplate"
              >
                點擊下載範例檔
              </u>
            </p>
            <p class="form-group">
              <span class="mark">* 檔案限制：[檔名].xlsx、[檔名].xls</span
              ><br />
              <span class="mark">* 大小限制：10MB 以下</span><br />
              <span class="mark">* 上傳前請確認是否符合格式</span><br />
            </p>
            <div class="from-group">
              <label for=""><span class="mark">*</span>檔案</label>
              <el-upload
                ref="upload"
                action
                accept=".xls,.xlsx"
                :auto-upload="false"
                :show-file-list="false"
                :on-change="uploadFile"
                :limit="1"
              >
                <el-button size="small" type="primary">點擊上傳</el-button>
              </el-upload>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- API 回應訊息 -->
    <ResponseDataModal
      :successfulList="successMessage"
      :failedList="failMessage"
    />
  </div>
</template>

<script>
/* global $ */
import { mapGetters, mapActions } from "vuex";
import { VueTreeList, Tree } from "vue-tree-list";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

import ResponseDataModal from "@/components/back/Modal/ResponseData";

import AddDepartment from "@/components/back/AddDepartment.vue";
import { config } from "@/components/back/table_config.js";

export default {
  name: "Department",

  components: {
    VueTreeList,
    Treeselect,
    AddDepartment,
    ResponseDataModal,
  },
  data() {
    return {
      // 匯入資料 API 回應訊息
      successMessage: [], // 成功訊息
      failMessage: [], // 失敗訊息

      // 角色
      roleOptions: [], // 列表
      personRoles: [],

      // 部門
      departmentList: [], // 列表
      selectedNode: null, // 目前點擊的Node
      selectedDepartmentGuid: null, // 目前點擊的部門Guid
      isAddDepartment: true,
      canDelete: false,

      // 人員
      searchType: "",
      searchKeyword: null,
      isPersonAdd: false,
      mainDepartment: {}, // 主要部門
      // 選取兼任部門
      addOthersDepartment: false,
      othersDepartment: [], // 兼任部門

      // data
      person: {},

      // 部門(Tree)
      tree: new Tree([]), // 部門
      rootGuid: null, // 主部門Guid

      ParentDepartmentName: null, // 上層部門名稱
      department: {}, // 部門Data

      // 人員 table
      rows: [],
      totalData: 0,

      // table data
      tableInfo: {
        // 分頁資訊
        page: 1,
        per_page: 10,
      },

      columns: [
        {
          label: this.i18n("ORGANIZATION.ACCOUNT"),
          name: "Account",
          slot_name: "account",
        },
        {
          label: this.i18n("ORGANIZATION.USERNAME"),
          name: "Name",
        },
        {
          label: this.i18n("ORGANIZATION.EMAIL"),
          name: "Email",
        },
        {
          label: this.i18n("ORGANIZATION.PHONE"),
          name: "PhoneNumber",
        },
        {
          label: this.i18n("ORGANIZATION.IS_SUPERVISOR"),
          name: "IsSupervisor",
          slot_name: "slot_supervisor",
        },
        {
          label: "啟用",
          name: "IsEnabled",
          slot_name: "slot_IsEnabled",
        },
        {
          label: "",
          slot_name: "delete",
        },
      ],

      config: {
        ...config,
        server_mode: true,
      },
    };
  },

  computed: {
    ...mapGetters(["lang"]),
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  watch: {
    lang: function () {
      this.columns = [
        {
          label: this.i18n("ORGANIZATION.ACCOUNT"),
          name: "Account",
          slot_name: "account",
        },
        { label: this.i18n("ORGANIZATION.USERNAME"), name: "Name" },
        { label: this.i18n("ORGANIZATION.EMAIL"), name: "Email" },
        { label: this.i18n("ORGANIZATION.PHONE"), name: "PhoneNumber" },
        {
          label: this.i18n("ORGANIZATION.IS_SUPERVISOR"),
          name: "IsSupervisor",
          slot_name: "slot_supervisor",
        },
        {
          label: "啟用",
          name: "IsEnabled",
          slot_name: "slot_IsEnabled",
        },
        { label: "", slot_name: "delete" },
      ];
    },
  },

  methods: {
    // 取得 部門
    getDepartment() {
      this.updateLoading(true);
      this.$api.department.getDepartment().then((response) => {
        if (response.status === 200) {
          this.departmentList = response.data;
          this.tree = new Tree([
            {
              DepartmentGuid: response.data[0].DepartmentGuid,
              DepartmentCode: response.data[0].DepartmentCode,
              DepartmentName: response.data[0].DepartmentName,
              ParentDepartmentGuid: response.data[0].ParentDepartmentGuid,
              delNodeDisabled: true,
              dragDisabled: true,
              children: response.data[0].children,
            },
          ]);
          this.rootGuid = response.data[0].DepartmentGuid;
        }
        this.updateLoading(false);
      });
    },

    ///////////////////////////  查詢人員 API  ///////////////////////////////////////////
    searchPerson({ page, per_page }) {
      this.updateLoading(true);
      this.searchType = "keyword";
      this.$api.backgroundUser
        .getBackgroundUserPaging({
          keyword: this.searchKeyword,
          page: page,
          perPage: per_page,
        })
        .then((response) => {
          if (response.status === 200) {
            this.rows = response.data.Data;
            this.totalData = response.data.SearchQuantity;
          }
          this.updateLoading(false);
        });
    },

    ///////////////////////////  人員 新增&編輯 Modal ///////////////////////////////////////////
    personModal(isAdd, item) {
      if (!isAdd) {
        this.getPersonDepartment(item.Account);
        this.getPersonRole(item.Account);
        this.person = {
          Account: item.Account,
          UserName: item.Name,
          EmployeeNo: item.EmployeeNo,
          Email: item.Email,
          PhoneNumber: item.PhoneNumber,
        };
        this.isPersonAdd = false;
      } else {
        this.person = {};
        this.mainDepartment = {
          Seq: 0,
          DepartmentGuid: null,
          IsSupervisor: false,
        };
        this.personRoles = [];
        this.othersDepartment = [];
        this.isPersonAdd = true;
      }
      this.addOthersDepartment = false;
      this.$refs.person.reset();
    },

    // 取得人員歸屬部門
    getPersonDepartment(item) {
      const vm = this;
      const account = item;
      const api = `${window.endpoints.api}/auth/backgrounduser/department/${account}`;

      vm.$http
        .get(api)
        .then((response) => {
          if (response.status === 200) {
            vm.othersDepartment = [];
            response.data.forEach((item) => {
              if (item.Seq === 0) {
                vm.mainDepartment = {
                  DepartmentGuid: item.DepartmentGuid,
                  IsSupervisor: item.IsSupervisor,
                  Seq: item.Seq,
                };
              } else {
                vm.othersDepartment.push(item);
              }
            });
          }
        })
        .catch((error) => {
          vm.$notify({
            title: "失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 取得人員擁有角色
    getPersonRole(item) {
      const vm = this;
      const api = `${window.endpoints.api}/auth/backgrounduser/roles/${item}`;

      vm.$http
        .get(api)
        .then((response) => {
          if (response.status === 200) {
            vm.personRoles = response.data;
          }
        })
        .catch((error) => {
          vm.$notify({
            title: "失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 刪除兼任部門
    delItem(id) {
      this.othersDepartment.splice(id, 1);
    },
    // 儲存兼任部門
    saveData(item) {
      this.addOthersDepartment = false;
      this.othersDepartment.push({ ...item });
    },

    // 人員 新增&編輯 API
    savePerson() {
      const vm = this;

      let api = `${window.endpoints.api}/auth/backgrounduser`;
      let httpMethod = "post";
      let message = "人員新增成功";

      if (!vm.isPersonAdd) {
        httpMethod = "put";
        message = "人員編輯成功";
      }

      // 兼任部門
      let othersDepartment = [];
      if (vm.othersDepartment.length > 0) {
        vm.othersDepartment.map((item, index) => {
          let data = {
            Seq: ++index,
            DepartmentGuid: item.DepartmentGuid,
            IsSupervisor: item.IsSupervisor,
          };
          othersDepartment.push(data);
        });
      }

      const data = {
        ...vm.person,
        Departments: [vm.mainDepartment, ...othersDepartment],
        Roles: vm.personRoles,
      };

      $("#personModal").modal("hide");
      vm.$store.dispatch("updateLoading", true);

      vm.$http[httpMethod](api, data)
        .then((response) => {
          if (response.status === 200) {
            vm.selectedNode = vm.mainDepartment.DepartmentGuid;
            vm.selectedDepartmentGuid = vm.mainDepartment.DepartmentGuid;
            vm.$store.dispatch("updateLoading", false);
            vm.$notify({
              title: "成功",
              message: message,
              type: "success",
              duration: 2000,
            });
            vm.$nextTick(function () {
              vm.getPerson({
                page: vm.tableInfo.page,
                per_page: vm.tableInfo.per_page,
              });
            });
          }
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          vm.$notify({
            title: "失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 設定主管 API
    setSupervisor(item) {
      const vm = this;
      const api = `${window.endpoints.api}/BasicInformation/department/setsupervisor`;

      const data = {
        UserId: item.UserId,
        DepartmentGuid: item.DepartmentGuid,
        IsSupervisor: item.IsSupervisor,
      };

      vm.$http
        .post(api, data)
        .then((response) => {
          if (response.status === 200) {
            vm.$notify({
              title: "成功",
              message: "設定成功",
              type: "success",
              duration: 2000,
            });
          }
        })
        .catch((error) => {
          vm.$notify({
            title: "失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 帳號啟用 / 停用 API
    setIsEnabled(item) {
      const vm = this;
      const api = `${window.endpoints.api}/auth/backgrounduser/enable/${item.Account}`;

      vm.$http
        .post(api)
        .then((response) => {
          if (response.status === 200) {
            vm.$notify({
              title: "成功",
              message: "設定成功",
              type: "success",
              duration: 2000,
            });
          }
        })
        .catch((error) => {
          vm.$notify({
            title: "失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    ///////////////////////////////   部門  /////////////////////////////////////

    // 新增部門 Modal
    addDepartment(item) {
      this.isAddDepartment = true;
      this.ParentDepartmentName = item.DepartmentName;
      this.department = {
        ParentDepartmentGuid: item.DepartmentGuid,
      };
      this.$refs.department.reset();
      $("#departmentModal").modal("show");
    },

    // 編輯部門 Modal
    editDepartment(item) {
      this.isAddDepartment = false;
      this.department = {
        DepartmentGuid: item.DepartmentGuid,
        DepartmentCode: item.DepartmentCode,
        DepartmentName: item.DepartmentName,
        ParentDepartmentGuid: item.ParentDepartmentGuid,
      };
      if (item.pid === 0) {
        this.department.ParentDepartmentGuid = null;
      }
      this.$refs.department.reset();
      $("#departmentModal").modal("show");
    },

    ///////////////////////////   部門 新增&編輯 API  /////////////////////////////////////////
    saveDepartment() {
      const vm = this;
      const api = `${window.endpoints.api}/BasicInformation/department`;

      let httpMethod = "post";
      let message = "部門新增成功";

      if (!vm.isAddDepartment) {
        httpMethod = "put";
        message = "部門編輯成功";
      }

      const data = { ...vm.department };
      $("#departmentModal").modal("hide");

      this.$nextTick(function () {
        vm.$store.dispatch("updateLoading", true);

        vm.$http[httpMethod](api, data)
          .then((response) => {
            if (response.status === 200) {
              vm.$store.dispatch("updateLoading", false);
              vm.$notify({
                title: "成功",
                message: message,
                type: "success",
                duration: 2000,
              });
              vm.getDepartment();
            }
          })
          .catch((error) => {
            vm.$store.dispatch("updateLoading", false);
            vm.$notify({
              title: "失敗",
              message: error.response.data,
              type: "error",
              duration: 3500,
            });
          });
      });
    },

    ///////////////////////////  拖拉部門 API  /////////////////////////////////////////
    drop(e) {
      if (e.node === e.target) {
        return;
      }
      const vm = this;
      const api = `${window.endpoints.api}/BasicInformation/department`;

      const data = {
        DepartmentGuid: e.node.DepartmentGuid,
        DepartmentCode: e.node.DepartmentCode,
        DepartmentName: e.node.DepartmentName,
        ParentDepartmentGuid: e.target.DepartmentGuid,
      };

      vm.$http
        .put(api, data)
        .then((response) => {
          if (response.status === 200) {
            vm.$notify({
              title: "成功",
              message: "部門移動成功",
              type: "success",
              duration: 2000,
            });
            vm.getDepartment();
          }
        })
        .catch((error) => {
          vm.$notify({
            title: "失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 刪除部門 Modal
    onDel(node) {
      this.department = {
        DepartmentGuid: node.DepartmentGuid,
        DepartmentName: node.DepartmentName,
      };
      this.canDelete = node.children === null && this.rows.length === 0;
      $("#delDepartmentModal").modal("show");
    },

    // 刪除部門 API
    delDepartment() {
      const vm = this;
      const DepartmentGuid = vm.department.DepartmentGuid;
      const api = `${window.endpoints.api}/BasicInformation/department/${DepartmentGuid}`;

      $("#delDepartmentModal").modal("hide");
      vm.$store.dispatch("updateLoading", true);

      vm.$http
        .delete(api)
        .then((response) => {
          if (response.status === 200) {
            vm.$store.dispatch("updateLoading", false);
            vm.$notify({
              title: "成功",
              message: "部門刪除成功",
              type: "success",
              duration: 2000,
            });
            vm.getDepartment();
          }
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          vm.$notify({
            title: "失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 點擊部門
    onClick(node) {
      this.selectedNode = node.id;
      this.selectedDepartmentGuid = node.DepartmentGuid;
      this.DepartmentName = node.DepartmentName;
      this.getPerson({
        page: this.tableInfo.page,
        per_page: this.tableInfo.per_page,
      });
    },

    // 取得當前部門內人員
    getPerson({ page, per_page }) {
      this.searchType = "department";
      const vm = this;
      const api = `${window.endpoints.api}/BasicInformation/department/user/paging/${vm.selectedDepartmentGuid}`;

      const params = {
        page: page,
        perPage: per_page,
      };

      vm.$store.dispatch("updateLoading", true);
      vm.$http
        .get(api, { params })
        .then((response) => {
          if (response.status === 200) {
            vm.$store.dispatch("updateLoading", false);

            vm.rows = response.data.Datas;
            vm.totalData = response.data.Quantity;
          }
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          vm.$notify({
            title: "失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 變更密碼 API
    changePassword() {
      const vm = this;
      const api = `${window.endpoints.api}/auth/user/ChangePasswordByAdmin/${vm.person.Account}`;

      vm.$store.dispatch("updateLoading", true);
      vm.$http
        .post(api)
        .then((response) => {
          if (response.status === 200) {
            vm.$store.dispatch("updateLoading", false);
            vm.$notify({
              title: "成功",
              message: "已發送變更密碼信件",
              type: "success",
              duration: 2000,
            });
          }
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          vm.$notify({
            title: "失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    /////////////////////////////  刪除人員  /////////////////////////////////////

    // 刪除人員 Modal
    delModal(item) {
      this.person = {
        Name: item.Name,
        Account: item.Account,
      };
    },

    // 刪除部門內人員 API
    delPerson() {
      const vm = this;
      const api = `${window.endpoints.api}/auth/backgrounduser/${vm.person.Account}`;

      vm.$http
        .delete(api)
        .then((response) => {
          if (response.status === 200) {
            vm.$notify({
              title: "成功",
              message: "人員刪除成功",
              type: "success",
              duration: 2000,
            });
            vm.selectedDepartmentGuid === null
              ? vm.searchPerson({
                  page: vm.tableInfo.page,
                  per_page: vm.tableInfo.per_page,
                })
              : vm.getPerson({
                  page: vm.tableInfo.page,
                  per_page: vm.tableInfo.per_page,
                });
          }
        })
        .catch((error) => {
          vm.$notify({
            title: "失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 下載 範例檔
    downloadTemplate() {
      this.$api.department.departmentTemplateDownload().then((response) => {
        if (response.status === 200) {
          let filename = decodeURIComponent(
            decodeURIComponent(
              response.headers["content-disposition"].split(
                "filename*=UTF-8''"
              )[1]
            )
          );
          let blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement("a");
          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url);
        }
      });
    },

    // 上傳 組織結構
    uploadFile(file) {
      const isLt10M = file.size / 1024 / 1024 < 10;

      if (!isLt10M) {
        this.$notify({
          title: "失敗",
          message: "檔案大小不得超過10MB",
          type: "error",
          duration: 0,
        });
        return false;
      }

      let fd = new FormData();
      fd.append("file", file.raw);

      $("#uploadModal").modal("hide");
      this.updateLoading(true);
      this.$api.department.uploadOrgStructure(fd).then((response) => {
        if (response.status === 200) {
          this.successMessage = response.data.filter((item) => {
            return item.indexOf("成功") !== -1;
          });
          this.failMessage = response.data.filter((item) => {
            return item.indexOf("失敗") !== -1;
          });
          this.$store.commit("OpenResponseDataModal", true);
        }
        this.updateLoading(false);
        this.getDepartment();
      });
      this.$refs.upload.clearFiles();
    },

    async getData() {
      await this.getDepartment();
      // 取得 角色
      const role = await this.$api.role.getRole();
      this.roleOptions = role.data.map((user) => {
        return {
          id: user.Id,
          label: user.Name,
        };
      });
    },

    // 分頁
    onChangeQuery(queryParams) {
      this.tableInfo = queryParams;
      switch (this.searchType) {
        case "keyword":
          this.searchPerson({
            page: this.tableInfo.page,
            per_page: this.tableInfo.per_page,
          });
          break;
        case "department":
          this.getPerson({
            page: this.tableInfo.page,
            per_page: this.tableInfo.per_page,
          });
          break;
        default:
          break;
      }
    },

    // loading
    ...mapActions(["updateLoading"]),

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  created() {
    this.getData();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
    this.$notify.close();
  },
};
</script>

<style lang="scss" scoped>
.vtl {
  .vtl-drag-disabled {
    background-color: transparent;
    &:hover {
      background-color: #d0cfcf;
    }
  }
  .vtl-disabled {
    background-color: #d0cfcf;
  }
}

.vtl-tree-node {
  cursor: move;
}
.vtl-node-main {
  padding: 0;
  transition: all 0.2s !important;
  &:hover {
    background-color: transparent !important;
  }
}

.vtl-border.vtl-up {
  margin-top: 0px;
}

.vtl-border {
  height: 0;
}

.department-name {
  font-size: 1.1em;
}
.department-code {
  font-size: 0.9em;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 15px;
  padding: 0 10px;
}

.department-edit-card {
  padding: 20px;
  text-align: right;
  background-color: #fff;
  border-radius: 5px;
  padding-bottom: 0;
  input {
    background-color: #f4f6ff;
    border: none;
    line-height: 34px;
    padding: 0 15px;
    margin-right: 10px;
    vertical-align: middle;
    border-radius: 5px;
  }
}

.content-wrap {
  display: flex;
  height: calc(100vh - 160px);
  .tree-wrap {
    margin-right: 10px;
    background-color: #fff;
    padding: 30px;
    border-radius: 5px;
    width: 500px;
    overflow: auto;

    & > .vtl {
      border: none;
    }

    .edit-folder,
    .add-folder {
      background: #d7e6ff;
      display: inline-block;
      width: 25px;
      height: 25px;
      line-height: 25px;
      text-align: center;
      border-radius: 50%;
      cursor: pointer;
      i {
        opacity: 0.7;
      }
    }
    .delete-folder {
      background: #f77373;
      display: inline-block;
      width: 25px;
      height: 25px;
      line-height: 25px;
      text-align: center;
      margin-left: 3px;
      border-radius: 50%;
      cursor: pointer;
      opacity: 0.7;
    }
  }

  .department-wrap {
    flex: 1;
    min-width: 1px;
    background-color: #fff;
  }
}

.node {
  padding: 5px;
  font-size: 0.8em;
  white-space: nowrap;

  .node-content {
    padding: 5px;
    border-left: #fff 5px solid;
  }

  &.active-node {
    .node-content {
      background-color: #f7f7f7;
      border-left: #303c50 5px solid;
      display: block;
    }

    .department-code {
      background-color: rgba(255, 255, 255, 0.3);
    }
  }
}

.graypic {
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: grayscale(100%);
  filter: gray;
}
</style>
